module.exports = __webpack_public_path__ + "img/quick-rody.0b8c829f.png";